import React from 'react';


function SkeletonLoader({ count }) {
  const loaderItems = [];
  for (let i = 0; i < count; i++) {
    loaderItems.push(i);
  }

  return (
    <div className="skeleton-loader">
      <div className="image-loader" />
      <div className="title-loader" />
    </div>

  );
}

export default React.memo(SkeletonLoader);
